import {
  Box, Dialog, IconButton, Tab, Table,
  TableBody, TableCell, TableHead, TableRow, TextField,
  Tooltip, Typography
} from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation'

const ocularState = {
  ocularListData: [],
  patient_details: {},
  clinic_id: '',
  appointment_id: '',
  patient_id: '',
  ocularComments: '',
  prevOcularComments: '',
  prevOcularListData: [],
  openComparePopup: false,
  enableCompare: false,
  enableCopy: false,
  dupOcularComments: '',
  dupOcularListData: '[]'
}

const UmaOcularResponse = React.forwardRef((props, ref) => {
  const [ocular, setOcular] = useState(ocularState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - OCULAR RESPONSE ANALYZER`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - OCULAR RESPONSE ANALYZER`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performOcularResponseAction: () => {
      if ((JSON.stringify(ocular.ocularListData) !== ocular.dupOcularListData) || JSON.stringify(ocular.ocularComments) !== ocular.dupOcularComments) {
        postOcularResponseAnalyserData()
      }
    }
  }))

  const apicalls = async () => {
    await getOcularResponseAnalyserData()
    await getPrevOcularResponseAnalyserData()
  }

  const getOcularResponseAnalyserData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_RESP_ANALYSER + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let ocularList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        let ocularArray = [
          { "eye_type": "RE", "ipocc": '', "ch": '', "ipog": '', "ws": '' },
          { "eye_type": "LE", "ipocc": '', "ch": '', "ipog": '', "ws": '' }
        ]
        let copy = Object.keys(ocularList)?.length > 0 ? ocularList?.ocular_response?.some(item => (item?.ipocc !== '' || item?.ch !== '' || item?.ipog !== '' || item?.ws !== '')) : false
        setOcular((prev) => ({
          ...prev,
          ocularListData: Object.keys(ocularList)?.length > 0 ? ocularList?.ocular_response : ocularArray,
          ocularComments: Object.keys(ocularList)?.length > 0 ? ocularList?.comments : '',
          dupOcularListData: Object.keys(ocularList)?.length > 0 ? JSON.stringify(ocularList?.ocular_response) : JSON.stringify(ocularArray),
          dupOcularComments: Object.keys(ocularList)?.length > 0 ? JSON.stringify(ocularList?.comments) : JSON.stringify(''),
          enableCopy: copy
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const getPrevOcularResponseAnalyserData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_RESP_ANALYSER_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let ocularList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        let compare = Object.keys(ocularList)?.length > 0 ? ocularList?.ocular_response?.some(item => (item?.ipocc !== '' || item?.ch !== '' || item?.ipog !== '' || item?.ws !== '')) : false
        let copy = Object.keys(ocularList)?.length > 0 ? ocularList?.ocular_response?.some(item => (item?.ipocc !== '' || item?.ch !== '' || item?.ipog !== '' || item?.ws !== '')) : false

        setOcular((prev) => ({
          ...prev,
          prevOcularListData: Object.keys(ocularList)?.length > 0 ? ocularList?.ocular_response : [],
          prevOcularComments: Object.keys(ocularList)?.length > 0 ? ocularList?.comments : '',
          enableCompare: compare,
          enableCopy: copy
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const postOcularResponseAnalyserData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        comments: ocular.ocularComments,
        ocular_response: ocular.ocularListData
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_OCULAR_RESP_ANALYSER)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getOcularResponseAnalyserData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const renderComparePopup = () => {
    try {
      return (
        <Dialog open={ocular.openComparePopup} maxWidth="md" fullWidth>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Compare Ocular Response Analyzer</Typography>
              <IconButton emed_tid='cmp_prev_cls'
                onClick={() => setOcular((prev) => ({ ...prev, openComparePopup: false }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Current Ocular Response</Typography>
                <Tooltip placement='top' arrow title={'Copy'}>
                  <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                    onClick={() => {
                      setOcular((prev) => ({
                        ...prev,
                        ocularListData: ocular.prevOcularListData,
                        ocularComments: ocular.prevOcularComments,
                        openComparePopup: false
                      }))
                    }}
                  ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
              </Box>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>IOPcc</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>IOPg</TableCell>
                      <TableCell className='doc_notes_tbl_header'>WS</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ocular.prevOcularListData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ipocc}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ch}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ipog}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ws}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>New Ocular Response</Typography>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>IOPcc</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>IOPg</TableCell>
                      <TableCell className='doc_notes_tbl_header'>WS</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ocular.ocularListData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ipocc}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ch}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ipog}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.ws}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Box>
        </Dialog >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const textBox = (names, values, width, placeholders, index) => {
    try {
      return (
        <TextField
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          size='small'
          sx={{ width: width }}
          value={values}
          onChange={(e) => {
            let { value } = e.target
            if (CommonValidation.DecimalNumber(value) || value === '') {
              let ocularData = [...ocular.ocularListData]
              ocularData[index] = { ...ocularData[index], [names]: value }
              setOcular((prev) => ({ ...prev, ocularListData: ocularData }))
            }
          }}
          placeholder={placeholders}
          InputProps={{ style: { height: COMMON_STYLE.HEIGHT }, emed_tid: names }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography className='doc_notes_header_card_font'>Ocular Response Analyzer</Typography>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='ocu_cpy'
                disabled={!ocular.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => {
                  setOcular((prev) => ({
                    ...prev,
                    ocularListData: ocular?.prevOcularListData
                  }))
                }}
              ><ContentCopyIcon color={ocular.enableCopy ? 'primary' : ''} /></IconButton></Tooltip>
              <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='ocu_view'
                disabled={!(ocular.enableCompare && ocular.enableCopy) || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => setOcular((prev) => ({ ...prev, openComparePopup: true }))}
              ><VisibilityIcon color={(ocular.enableCompare && ocular.enableCopy) ? 'primary' : ''} /></IconButton></Tooltip>
            </Box>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                    <TableCell className='doc_notes_tbl_header'>IOPcc</TableCell>
                    <TableCell className='doc_notes_tbl_header'>CH</TableCell>
                    <TableCell className='doc_notes_tbl_header'>IOPg</TableCell>
                    <TableCell className='doc_notes_tbl_header'>WS</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ocular?.ocularListData?.length > 0 ? ocular?.ocularListData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('ipocc', item?.ipocc, '5dvw', 'IOPcc', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('ch', item?.ch, '5dvw', 'CH', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('ipog', item?.ipog, '5dvw', 'IOPg', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('ws', item?.ws, '5dvw', 'WS', index)}
                        </TableCell>
                      </TableRow>
                    )
                  }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={ocular.ocularComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                    setOcular((prev) => ({ ...prev, ocularComments: value }))
                  }
                }}
                placeholder='Comments'
                InputProps={{ emed_tid: 'ocu_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
              />
            </Box>
          </Box>
        </Box>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
        {renderComparePopup()}
      </Box>
    </ShowComponents>
  )
})

export default UmaOcularResponse